import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-orientation-pointer',
  templateUrl: './orientation-pointer.component.html',
  styleUrls: ['./orientation-pointer.component.scss']
})
export class OrientationPointerComponent {
  @Input() orientation: number;
  @Input() textColorClass: string = 'text-blue1';
  @Input() pointerColorClasses: string = '!border-sun-yellow';

}
